import { getAccountInfo } from '../../api/account/account'
import { Account } from '../../api/account/types'
import { APIError } from '../../api/types'
import { createRequestThunk } from '../store.helpers'
import { getAccountActions } from './account.actions'

export const getAccount = createRequestThunk<void, Account, APIError>(getAccountActions, getAccountInfo)
